<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col justify-center items-center space-y-1 lg:space-y-3">
    <h2 class="text-default-500 font-bold text-center text-2xl lg:text-[40px] leading-[30px] lg:leading-[46px]">{{ t('page.create_business.finish.title') }}</h2>
    <span class="text-overcast-night font-medium text-wrap text-center text-sm lg:text-lg">{{ t('page.create_business.finish.desc') }}</span>
  </div>
  <div class="flex-1 flex flex-col justify-center items-center space-y-3 gap-y-2 mt-10 w-full">
    <div class="flex justify-center items-center w-50 h-50 rounded-full bg-primary ring-4 ring-heart-purple ring-offset-10">
      <UIcon name="i-approved-check" class="size-30 text-white" />
    </div>
  </div>
</template>